import { featured } from "@/mocks/guage";

export default function FeatureSection() {
  return (
    <section id="feature" className="w-full bg-background-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
          <article className="lg:col-span-8">
            <span className="inline-flex items-center gap-2 text-primary-700 text-xs md:text-sm font-medium">
              <span className="w-6 h-px bg-primary-500"></span>
              精选长评
            </span>
            <h2 className="mt-4 font-heading text-3xl md:text-5xl leading-tight text-foreground-950 text-balance">
              {featured.title}
            </h2>
            <p className="mt-4 text-xs md:text-sm text-foreground-500">{featured.meta}</p>

            <div className="mt-6 h-56 md:h-80 rounded-lg overflow-hidden border border-background-200">
              <img
                src={featured.image}
                alt={`${featured.title} 配图`}
                title={`${featured.title} · 瓜哥吃瓜精选长评`}
                className="w-full h-full object-cover object-top"
              />
            </div>

            <p className="mt-6 text-base md:text-lg text-foreground-800 leading-relaxed font-medium">
              {featured.lead}
            </p>

            <div className="mt-8 space-y-8">
              {featured.paragraphs.map((block, index) => (
                <div key={block.h} id={`feature-${index + 1}`}>
                  <h3 className="flex items-center gap-3 font-heading text-2xl md:text-3xl text-foreground-950">
                    <span className="font-heading text-lg w-8 h-8 flex items-center justify-center rounded-md bg-primary-100 text-primary-700 shrink-0">
                      {index + 1}
                    </span>
                    {block.h}
                  </h3>
                  <p className="mt-3 text-sm md:text-base text-foreground-600 leading-loose">
                    {block.p}
                  </p>
                </div>
              ))}
            </div>
          </article>

          <aside className="lg:col-span-4">
            <div className="lg:sticky lg:top-28 space-y-5">
              <nav className="p-5 md:p-6 rounded-lg bg-background-50 border border-background-200">
                <h3 className="font-heading text-xl text-foreground-950 flex items-center gap-2">
                  <i className="ri-list-check-2 text-primary-500"></i>
                  本篇目录
                </h3>
                <ol className="mt-4 space-y-3">
                  {featured.paragraphs.map((block, index) => (
                    <li key={block.h}>
                      <a
                        href={`#feature-${index + 1}`}
                        className="flex items-start gap-3 text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                      >
                        <span className="font-heading text-primary-500 shrink-0">
                          0{index + 1}
                        </span>
                        {block.h}
                      </a>
                    </li>
                  ))}
                </ol>
              </nav>

              <div className="p-5 md:p-6 rounded-lg bg-accent-100 border border-accent-200">
                <h3 className="font-heading text-xl text-accent-900">瓜哥的一句话</h3>
                <p className="mt-3 text-sm text-accent-900/85 leading-relaxed">
                  「围观是权利，判断是能力。热闹看完，记得把判断力带走。」
                </p>
              </div>

              <div className="p-5 md:p-6 rounded-lg bg-background-50 border border-background-200">
                <h3 className="font-heading text-xl text-foreground-950">相关阅读</h3>
                <ul className="mt-4 space-y-3 text-sm">
                  <li>
                    <a href="#roast" className="flex items-center justify-between gap-3 text-foreground-600 hover:text-primary-600 transition-colors">
                      顶流塌房连环瓜时间线
                      <i className="ri-arrow-right-s-line"></i>
                    </a>
                  </li>
                  <li>
                    <a href="#roast" className="flex items-center justify-between gap-3 text-foreground-600 hover:text-primary-600 transition-colors">
                      公关稿写成大型自曝
                      <i className="ri-arrow-right-s-line"></i>
                    </a>
                  </li>
                  <li>
                    <a href="#quotes" className="flex items-center justify-between gap-3 text-foreground-600 hover:text-primary-600 transition-colors">
                      舆论场金句弹幕合集
                      <i className="ri-arrow-right-s-line"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}